import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../index.css";

export class Navbar extends Component {
  render() {
    return (
      <div>
        <nav className="nv-s nv-s--c">
          <input type="checkbox" id="nv-s-tr" className="nv-s-tr" aria-hidden="true" />

          <ul className="nv-s-l">
            <li className="nv-s-l-i">
              <label className="nv-s-l-b">Tasty Sins By Ari</label>
            </li>

            <li className="nv-s-l-i">
              <Link className="nv-s-l-a nv-s-l-a--active" to="/">
                Tasty Sins By Ari
              </Link>
            </li>
            <li className="nv-s-l-i">
              <Link className="nv-s-l-a" to="/AboutUs">
                About Us
              </Link>
            </li>
            <li className="nv-s-l-i">
              <Link className="nv-s-l-a" to="/Catering">
                Catering
              </Link>
            </li>
            <li className="nv-s-l-i">
              <Link className="nv-s-l-a" to="/FoodGallery">
                Food Gallery
              </Link>
            </li>
            <li className="nv-s-l-i">
              <Link className="nv-s-l-a" to="/Locations">
                Locations
              </Link>
            </li>
            <li className="nv-s-l-i">
              <Link className="nv-s-l-a" to="/ContactUs">
                Order
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default Navbar;
